import { render, staticRenderFns } from "./DataImporter.vue?vue&type=template&id=3f8e4638&scoped=true&"
import script from "./DataImporter.vue?vue&type=script&lang=ts&"
export * from "./DataImporter.vue?vue&type=script&lang=ts&"
import style0 from "./DataImporter.vue?vue&type=style&index=0&id=3f8e4638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e4638",
  null
  
)

export default component.exports